import React from 'react'
import PropTypes from 'prop-types'
import ImmutablePropTypes from 'react-immutable-proptypes'
import { connect } from 'react-redux'
import { Map } from 'immutable'
import Icon from '../Icon/index'
import LearnerLevelBeginnerIcon from '../Icon/icons/LearnerLevelBeginner/index'
import LearnerLevelIntermediateIcon from '../Icon/icons/LearnerLevelIntermediate/index'
import LearnerLevelAdvancedIcon from '../Icon/icons/LearnerLevelAdvanced/index'

const CANONICAL_LEVELS = ['Beginner', 'Intermediate', 'Advanced']
const ICON_SIZE = 9
const LEVEL_ICON = {
  beginner: { Icon: LearnerLevelBeginnerIcon },
  intermediate: { Icon: LearnerLevelIntermediateIcon },
  advanced: { Icon: LearnerLevelAdvancedIcon },
}

function normalizeLearnerLevel (learnerLevelLabel) {
  const raw = String(learnerLevelLabel ?? '').trim()
  if (!raw) {
    return null
  }
  return CANONICAL_LEVELS.find((level) => level.toLowerCase() === raw.toLowerCase()) || null
}

/**
 * Shared learner level row (icon + localized label).
 * Copy lives in `components/LearnerLevelLabel/lang_*.json` (Redux staticText slice
 * `learnerLevelLabel`).
 * @param {Object} props
 * @param {string} props.learnerLevelLabel - Beginner | Intermediate | Advanced
 * @param {import('immutable').Map} props.staticText - Injected from connect
 * @param {string} [props.className] - Extra root classes when provided
 */
function LearnerLevelLabel (props) {
  const {
    learnerLevelLabel,
    staticText,
    className,
  } = props

  const level = normalizeLearnerLevel(learnerLevelLabel)
  if (!level || !Map.isMap(staticText)) {
    return null
  }

  const modifier = level.toLowerCase()
  const levelIcon = LEVEL_ICON[modifier]
  if (!levelIcon) {
    return null
  }
  const { Icon: LevelIcon } = levelIcon

  const rootClass = ['learner-level-label', className]
    .filter(Boolean)
    .join(' ')

  return (
    <div className={rootClass}>
      <Icon className="learner-level-label__icon" size={ICON_SIZE}>
        <LevelIcon />
      </Icon>
      <span className="learner-level-label__text">{staticText.get(modifier)}</span>
    </div>
  )
}

LearnerLevelLabel.propTypes = {
  learnerLevelLabel: PropTypes.string,
  staticText: ImmutablePropTypes.map.isRequired,
  className: PropTypes.string,
}

export default connect((state) => ({
  staticText: state.staticText.getIn(['data', 'learnerLevelLabel', 'data'], Map()),
}))(React.memo(LearnerLevelLabel))
